import React, {Component} from "react";
import './Currency.scss'
import flagUS from '../assets/images/flag_united_states.ico'
import flagEU from '../assets/images/flag_europe.ico'
import flagRU from '../assets/images/flag_russia.ico'
import flagPL from '../assets/images/flag_poland.ico'
import flagUA from '../assets/images/flag_ukraine.ico'
import monoBankLogo from "../assets/images/monobank-logo.png";

class Currency extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        let url = "https://api.monobank.ua/bank/currency";
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                // Примечание: важно обрабатывать ошибки именно здесь, а не в блоке catch(),
                // чтобы не перехватывать исключения из ошибок в самих компонентах.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            return <div>Ошибка: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Загрузка...</div>;
        } else if (Array.isArray(items)) {

            function cData(value) {
                let d =  new Date(value * 1000);
                return d.getDate() + "." + (d.getMonth() + 1) + "." + d.getFullYear() + " " +
                    d.getHours() + ":" + d.getMinutes();
            }

            function getNameCurrency(ico_code) {
                let currencyName = "";
                switch (ico_code) {
                    case 980:
                        return currencyName = "UAH";
                    case 643:
                        return currencyName = "RUR";
                    case 985:
                        return currencyName = "PLN";
                    case 978:
                        return currencyName = "EUR";
                    case 840:
                        return currencyName = "USD";
                    default:
                        return currencyName = ico_code;
                }
            }

            function getIcoCurrency(ico_code) {
                let icoCurrency = "";
                switch (ico_code) {
                    case 978:
                        return icoCurrency = flagEU;
                    case 840:
                        return icoCurrency = flagUS;
                    case 985:
                        return icoCurrency = flagPL;
                    case 643:
                        return icoCurrency = flagRU;
                    default:
                        return icoCurrency = flagUA;
                }
            }

            return (
                <div className='currency'>
                    <div className='logo-bank'>
                        <img src={monoBankLogo}/>
                    </div>
                    <div>
                        <div className='currency-item-header'>
                            <div> </div>
                            <div>Покупка</div>
                            <div>Продажа</div>
                        </div>
                        {items.map((item, index) => (
                            <div key={index}>
                                {(item.currencyCodeA === 840 || item.currencyCodeA === 978 || item.currencyCodeA === 985 || item.currencyCodeA === 643)
                                    ?
                                    <div className='currency-item-container'>
                                        <div className="currency-item currency-item-left">
                                            <div><img className="currency-icon" src={getIcoCurrency(item.currencyCodeA)} alt="currency ico" /></div>
                                            <div>{(item.currencyCodeA === 978 && item.currencyCodeB === 840 ) ? 'EUR / USD' : getNameCurrency(item.currencyCodeA) + ' / ' + getNameCurrency(item.currencyCodeB)}</div>
                                        </div>
                                        <div className="currency-item">
                                            {/*<div>Дата {cData(item.date)}</div>*/}
                                            <div className='currency-value'>{(item.rateBuy) ? ((parseInt(item.rateBuy * 100)) / 100).toFixed(2) : ((parseInt(item.rateCross * 100)) / 100).toFixed(2) }</div>
                                            <div className='currency-value'>{(item.rateSell) ? ((parseInt(item.rateSell * 100)) / 100).toFixed(2) : ((parseInt(item.rateCross * 100)) / 100).toFixed(2) }</div>
                                        </div>
                                    </div>

                                    : ""
                                }
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                    { (Array.isArray(items))
                        ? ""
                        : 'Ошибка: ' + items.errorDescription + '. Попробуйте чуть позже.'
                    }
                </div>
            )
        }
    }

}

export default Currency;
